<template>
  <div
    class="add-purchase-card"
    :class="Number(data.saleStatus.isCanBuy) === 1 ? 'pointer' : 'no-pointer'"
  >
    <div
      class="card-choose"
      @click="
        handleChoose({
          courseId: data.id,
          classId: data.class.id,
          isCanBuy: data.saleStatus.isCanBuy,
          totalPrice: data.totalPrice
        })
      "
    >
      <div class="card-choose__btn">
        <p
          class="card-choose__circle"
          :class="{
            'circle-color': Number(data.saleStatus.isCanBuy) === 1,
            chooseCard: Number(data.id) === Number(currentCourseId)
          }"
        ></p>
        <p
          class="card-choose__text"
          :class="Number(data.saleStatus.isCanBuy) === 1 ? 'text-color' : 'text-not'"
          :style="{ 'color:#f13232;': Number(data.id) === Number(currentCourseId) }"
        >
          选择课程
        </p>
      </div>
      <div class="card-choose__detail" v-if="Number(data.saleStatus.isCanBuy) !== 1">
        <img
          src="../img/buy_notice.png"
          v-if="Number(data.saleStatus.type) === 7 || Number(data.saleStatus.type) === 6"
        />
        <div class="card-choose__diagnose">
          <span class="card-choose__text">{{
            Number(data.saleStatus.type) === 7 || Number(data.saleStatus.type) === 6
              ? data.saleStatus.title
              : data.saleStatus.reason
          }}</span>
          <div
            class="activety__illustrate"
            v-if="
              Number(data.saleStatus.type) === 7 || Number(data.saleStatus.type) === 6
            "
          >
            <p>{{ data.saleStatus.title }}</p>
            <p>
              {{
                Number(data.saleStatus.type) === 6
                  ? data.saleStatus.reason
                  : '在该课程的课程详情，点击“诊断后报名” 通过诊断考试，才能选择该课程'
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="course-card" target="_blank" @click="handleClick($event)" v-if="data">
      <p class="card-title">
        <span
          v-if="courseType === courseEnum.literacy"
          class="card-title__solid card-title__icon"
          >{{ Number(data.category) !== 1 ? '直播' : '录播' }}</span
        >
        <span class="card-title__solid card-title__icon" v-if="data.isPackageCourse">
          {{ data.isClassBegin ? '已开课' : '未开课' }}
        </span>
        <span v-if="data.subjects[0].name" class="card-title__hollow card-title__icon">
          {{
            courseType === courseEnum.literacy
              ? data.subjects[0].name.substr(0, 6)
              : Number(data.subjects[0].id) === 25
              ? data.subjects[0].name
              : data.subjects[0].name.substr(0, 1)
          }}
        </span>
        <span v-html="data.name"></span>
      </p>
      <div class="card-info">
        <p
          class="card-info__sub-title"
          v-if="data.otherTitle"
          v-html="data.otherTitle"
        ></p>
        <p
          v-if="data.secondTitle && courseType !== courseEnum.liveThematic"
          class="card-info__secondTitle"
          v-html="data.secondTitle"
        ></p>
        <p class="card-info__data" v-if="data.schoolTimeName">
          <i class="iconfont1 icon-lishi"></i>&nbsp;{{ data.schoolTimeName }}
        </p>
        <p
          class="card-info__difficulty"
          v-if="
            data.difficulty && data.difficulty.alias && !/\D/.test(data.difficulty.alias)
          "
        >
          <span>难度：</span
          ><i
            v-for="index of Number(data.difficulty.alias)"
            :key="index"
            class="iconfont2 icon-star-fill"
          ></i>
        </p>
      </div>
      <div class="teacher-list">
        <!-- 主讲老师 -->
        <div
          class="teacher-list__item"
          v-if="data.chineseTeacher && data.chineseTeacher[0]"
        >
          <div
            class="teacher-list__item__avatar"
            :style="{
              backgroundImage: `url(${data.chineseTeacher[0].avatars &&
                data.chineseTeacher[0].avatars[0]})`
            }"
          ></div>
          <p class="teacher-list__item__job-title">
            {{ data.chineseTeacher[0].typeName }}
          </p>
          <p class="teacher-list__item__name">
            {{
              data.chineseTeacher.length > 1
                ? data.chineseTeacher[0].name + '等'
                : data.chineseTeacher[0].name
            }}
          </p>
        </div>
        <!-- 外教老师 -->
        <div
          class="teacher-list__item"
          v-if="
            data.foreignTeacher &&
              data.foreignTeacher[0] &&
              data.foreignTeacher[0].name &&
              data.foreignTeacher[0].typeName
          "
        >
          <div
            class="teacher-list__item__avatar"
            :style="{
              backgroundImage: `url(${data.foreignTeacher[0].avatars &&
                data.foreignTeacher[0].avatars[0]} )`
            }"
          ></div>
          <p class="teacher-list__item__job-title">
            {{ data.foreignTeacher[0].typeName }}
          </p>
          <p class="teacher-list__item__name">{{ data.foreignTeacher[0].name }}</p>
        </div>
        <!-- 辅导老师 -->
        <div
          class="teacher-list__item"
          v-if="
            data.isHaveCounselorTeacher === 1 &&
              data.class.counselor &&
              data.class.leftNum &&
              data.class.leftNum !== 0
          "
        >
          <div
            class="teacher-list__item__avatar"
            :style="{
              backgroundImage: `url(${data.class.counselor.avatars &&
                data.class.counselor.avatars[0]})`
            }"
          ></div>
          <template v-if="data.excTeacherCourse && data.excTeacherCourse === 1">
            <p class="teacher-list__item__job-title"></p>
            <p class="teacher-list__item__name">专属老师</p>
          </template>
          <template v-else>
            <p class="teacher-list__item__job-title">
              {{ data.class.counselor.typeName }}
            </p>
            <p class="teacher-list__item__name">{{ data.class.counselor.name }}</p>
            <!-- <div class="teacher-list__item__label" v-if="data.class.leftNum && data.class.leftNum > 0 && Number(data.saleStatus.type) !== 5 && Number(data.saleStatus.type) !== 7 && Number(data.saleStatus.type) !== 10 && Number(data.saleStatus.type) !== 12">
              名额有限
            </div> -->
            <div
              class="teacher-list__item__label"
              v-if="data.class.leftNum && data.class.leftNum !== 0"
            >
              余{{ data.class.leftNum }}名额
            </div>
          </template>
        </div>
      </div>
      <div class="card-border"></div>
      <div class="card-bottom">
        <div class="card-bottom__price">
          <span
            class="card-bottom__origin-price"
            v-if="Number(data.price.resale) !== Number(data.price.origin)"
            >￥{{ data.price.origin }}</span
          >
          <span>￥</span>
          <strong>{{ data.price.resale }}</strong>
        </div>
        <div class="card-bottom__desc" v-if="data.saletimes.countDown">
          {{ data.saletimes.countDown }}
        </div>
        <div class="card-bottom__num">共{{ data.syllabusNum }}讲</div>
      </div>
    </div>
  </div>
</template>

<script>
import { termsName, courseEnum } from '@/defines'
export default {
  name: 'course-card',
  props: [
    'data',
    'courseType',
    'index',
    'keyName',
    'clickId',
    'termId',
    'currentCourseId'
  ],
  data() {
    return {
      termsName,
      courseEnum,
      isChoose: false
    }
  },
  methods: {
    handleChoose(data) {
      if (Number(data.isCanBuy) === 1) {
        this.$emit('handleChange', data)
      }
    },
    computedTerm(terms) {
      if (terms.filter(i => i.name === 'year').length !== 0) {
        return termsName.year
      }
      return termsName[terms[0].name]
    },
    displayTeachers(chineseTeacher) {
      if (chineseTeacher.length > 1) {
        if (this.data.class.counselor) {
          if (chineseTeacher.length > 2) {
            chineseTeacher.slice(0, 2)
          }
        } else {
          if (chineseTeacher.length > 3) {
            chineseTeacher.slice(0, 3)
          }
        }
      }
      return chineseTeacher
    },
    handleClick(event) {
      this.handleLog(event)
      if (Number(this.data.saleStatus.isCanBuy) !== 1) {
        return
      }
      const courseDetailUrl = this.$router.resolve({
        name: 'course-detail',
        params: { courseId: this.data.id, classId: this.data.class.id },
        query: this.$route.query
      })
      window.open(`${window.location.origin}${courseDetailUrl.href}`)
    },
    // 日志
    handleLog(event) {
      const XESLog = new this.$XESLog({
        key: this.keyName,
        clickid: this.clickId,
        content: this.data,
        courseid: this.data.id,
        rankid: this.index,
        termid: this.termId,
        gradeid: this.$route.params.grade,
        subjectid: this.data.subjects[0].id,
        clickurl: this.computedURL(`/course-detail/${this.data.id}`)
      })
      XESLog.push({ eventname: 'click', target: event.target }, this.$route)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';
.add-purchase-card {
  display: inline-block;
  // border: 1px solid #e5e5e5;
  border-radius: 2px;
  position: relative;
  transition: all 0.2s linear;
  margin: 10.5px;
  &:hover {
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.05), -5px 0px 10px rgba(0, 0, 0, 0.05);
    border-top: 1px solid #f13232;
    transform: translate3d(0, -4px, 0);
    z-index: 99;
  }
}
@include b(course-card) {
  display: inline-block;
  width: 330px;
  background: #fff;
  position: relative;
  padding: 32px 27px 20px;
}

@include b(card-title) {
  white-space: normal;
  word-break: break-all;
  height: 54px;
  line-height: 1.42857143;
  font-size: 18px;
  color: #111;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  span {
    vertical-align: middle;
  }
  @include e(icon) {
    height: 18px;
    min-width: 18px;
    text-align: center;
    font-size: 14px;
    font-weight: normal;
    border-radius: 2px;
    display: inline-block;
    margin-right: 7px;
  }
  @include e(solid) {
    color: #fff;
    background-color: #f13232;
  }
  @include e(presale) {
    color: #fff;
    background-color: #ed773c;
  }
  @include e(hollow) {
    color: #f13232;
    border: 1px solid #f13232;
  }
}

@include b(card-info) {
  margin-top: 7px;
  color: #999999;
  height: 87px;
  overflow: hidden;
  font-size: 14px;
  @include e(sub-title) {
    font-size: 14px;
    margin-bottom: 3px;
    margin-top: 0;
    height: 23px;
    line-height: 23px;
    overflow: hidden;
    color: #ff6e24;
  }
  @include e(data) {
    margin: 2px 0;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  @include e(difficulty) {
    span {
      vertical-align: middle;
    }
    i {
      font-size: 14px;
      color: #666;
      vertical-align: middle;
      letter-spacing: 4px;
    }
  }
  @include e(secondTitle) {
    font-size: 14px;
    margin-bottom: 4px;
    line-height: 13px;
    color: #ff6e24;
  }
}

@include b(teacher-list) {
  margin-top: 5px;
  @include e(item) {
    display: inline-block;
    height: 105px;
    margin-right: 37px;
    text-align: center;
    width: 62px;
    position: relative;
    &:last-child {
      margin-right: 0;
    }
    p {
      text-align: center;
      color: #666666;
      font-size: 14px;
      height: 17px;
      line-height: 17px;
      overflow: hidden;
    }
    @include e(avatar) {
      width: 62px;
      height: 62px;
      overflow: hidden;
      border-radius: 50%;
      font-size: 0;
      text-align: center;
      border: 1px solid #f1f1f1;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      position: relative;
    }
    @include e(label) {
      position: absolute;
      right: -74px;
      top: 0px;
      max-width: 120%;
      text-align: center;
      background-image: url('//res12.xesimg.com/x5mall/img/student_num_label.png?20171211');
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      width: 74px;
      height: 23px;
      font-size: 12px;
      line-height: 23px;
      color: #f0773c;
    }
  }
}

.card-border {
  height: 0;
  overflow: hidden;
  margin: 20px auto 12px;
  border-top-color: #e5e5e5;
  border-top: 1px solid #ddd;
}

@include b(card-bottom) {
  height: 41px;
  position: relative;
  @include e(desc) {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 13px;
    height: 16px;
    line-height: 16px;
    color: #999999;
  }
  @include e(num) {
    position: absolute;
    bottom: 0;
    left: 0;
    font-size: 13px;
    height: 16px;
    line-height: 16px;
    color: #999999;
  }
  @include e(origin-price) {
    font-size: 14px;
    font-family: Arial;
    opacity: 0.8;
    color: #999;
    text-decoration: line-through;
  }
  @include e(price) {
    color: #f13232;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    font-size: 16px;
    strong {
      font-family: Arial;
      font-size: 32px;
    }
  }
  @include e(full) {
    font-size: 24px;
    color: #666;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }
}
.card-choose div,
.card-choose p,
.card-choose img {
  display: inline-block;
}
@include b(card-choose) {
  height: 48px;
  background-color: #fafafa;
  // border-top: #E5E5E5 solid 1px;
  padding: 0 26px;
  position: relative;
  .text-color {
    color: #858c96;
  }
  .circle-color {
    border: 1px solid #d9d9d9;
    opacity: 1;
  }
  &:hover {
    .text-color {
      color: #f13232;
    }
    .circle-color {
      border: 1px solid #f13232;
      opacity: 1;
    }
  }
  @include e(circle) {
    box-sizing: border-box;
    line-height: 48px;
    vertical-align: middle;
    width: 14px;
    height: 14px;
    color: #d9d9d9;
    border-radius: 100%;
    margin-right: 8px;
    background: #ffffff;
    border: 1px solid #d9d9d9;
    opacity: 0.5;
  }
  .text-not {
    color: #999999;
    opacity: 0.5;
  }
  @include e(text) {
    position: relative;
    line-height: 48px;
    font-size: 14px;
    vertical-align: middle;
    color: #858c96;
  }
  @include e(diagnose) {
    position: relative;
  }
  @include e(detail) {
    position: absolute;
    right: 26px;
    img {
      width: 13px;
      height: 13px;
      vertical-align: middle;
      margin-right: 4px;
    }
    cursor: pointer;
    &:hover {
      .activety__illustrate {
        display: block;
      }
    }
    .activety__illustrate {
      display: none;
      text-align: center;
      padding: 12px 12px;
      position: absolute;
      right: -93px;
      top: 42px;
      width: 274px;
      background: #fff;
      z-index: 105;
      box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.05);
      border-radius: 2px;
      &::before {
        right: 50%;
        pointer-events: none;
        position: absolute;
        display: block;
        content: '';
        width: 0;
        height: 0;
        border: 11px dashed transparent;
        z-index: 100;
        border-bottom-style: solid;
        border-width: 0 11px 11px;
        border-bottom-color: #e5e5e5;
        bottom: 0;
        top: -11px;
      }
      &::after {
        right: 50%;
        pointer-events: none;
        position: absolute;
        display: block;
        content: '';
        width: 0;
        height: 0;
        border: 11px dashed transparent;
        z-index: 100;
        border-bottom-style: solid;
        border-width: 0 11px 11px;
        top: -10px;
        border-bottom-color: #ffffff;
        bottom: -1px;
      }
    }
    .activety__illustrate p {
      margin: 0;
      padding: 0;
      text-align: center;
      line-height: 0px;
    }
    .activety__illustrate > p:first-child {
      color: #333333;
      font-size: 14px;
      line-height: 14px;
    }
    .activety__illustrate > p:last-child {
      color: #666666;
      font-size: 12px;
      line-height: 17px;
      margin-top: 8px;
    }
  }
}
.chooseCard {
  background-image: url('../img/checkBox.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border: none !important;
}
.pointer {
  cursor: pointer;
}
.no-pointer {
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// ./src/views/AddPurchase/components/CourseCard.vue